import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { Order } from '../model/order';

@Injectable()
export class OrderService {
	path = '/order/';

	constructor(private baseService: BaseService) {}

	put = (value: Order) => this.baseService.put(this.path, '', value);
	post = (value: Order) => this.baseService.post(this.path, '', value);

	getAll = (query) => this.baseService.get(this.path, '', query);
	getById = (id: number) => this.baseService.get(this.path, '' + id);
	getAllPost = (query) => this.baseService.post(this.path, 'getAll/', query);
	getPaginated = (query) => this.baseService.get(this.path, 'getAll/paginated/', query);

	distinct = (query) => this.baseService.get(this.path, 'distinct/', query);
	distinctFiltered = (query) => this.baseService.get(this.path, 'distinct-filtered/', query);

	delete = (id: number) => this.baseService.delete(this.path, '' + id + '/delete');
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/order.service.ts